import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

function initializeLink(res, link) {
  if (res && typeof res.hasLink === 'function' && res.hasLink(link)) {
    return res.links(link).href;
  } else {
    return '#';
  }
}

export class OrgModel extends ModeModelBase {
  override _name = 'organization';
  newReportLink: any;
  activityLink: any;
  searchLink: any;
  starredLink: any;
  inviteLink: any;
  uploadLink: any;
  homeLink: any;
  reportsLink: any;
  datasourceLink: any;
  override idAttribute = 'username';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override hasMany = [
    { name: 'reports', idAttribute: 'token' },
    { name: 'dataSources', idAttribute: 'token' },
    { name: 'tables', idAttribute: 'id' },
  ];
  override attributes = [
    { name: 'name', default: '' },
    { name: 'id', default: null },
    { name: 'avatar', default: {} },
    { name: 'token', default: '' },
    { name: 'authorized_domains', default: [] },
  ];
  override initialize(resource) {
    this.newReportLink = initializeLink(resource, 'new_report_web');
    this.activityLink = initializeLink(resource, 'home_activity_web');
    this.searchLink = initializeLink(resource, 'home_search_web');
    this.starredLink = initializeLink(resource, 'home_starred_web');
    this.inviteLink = initializeLink(resource, 'new_invite_web');
    this.uploadLink = initializeLink(resource, 'new_upload_web');
    this.homeLink = initializeLink(resource, 'home_web');
    this.reportsLink = initializeLink(resource, 'home_reports_web');
    this.datasourceLink = initializeLink(resource, 'select_data_sources_web');
  }
}

@Injectable({ providedIn: 'root' })
export class OrgModelAccessor extends ModelAccessorBase<OrgModel> {
  override name = 'organization';
  override idAttribute = 'username';
  override parentModel = 'account';
  override parentIdAttribute = 'username';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.organization');
  }

  createModel(resource, opts?) {
    const model = new OrgModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
